import { RedirectPage } from "components/UI/RedirectPage/RedirectPage.tsx";
import { Route as ValidationEditorPage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout/$scenarioId/_layout/editor";
import { Route as ValidationGeneralPage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout/$scenarioId/_layout/general";
import { PermissionEnum } from "types/enums.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute.ts";

export const Route = createTenantFileRoute(
    "/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout/$scenarioId/"
)({
    component: ValidationDetailPage,
    staticData: {
        permissions: [PermissionEnum.ToolScenarioFieldGeneral, PermissionEnum.ToolScenarioFieldEditor],
        showInSideMenu: false,
        label: "pages.tool.scenario.validation.detail.title",
        redirects: [ValidationGeneralPage, ValidationEditorPage],
        defaultRedirect: ValidationGeneralPage,
    },
});

function ValidationDetailPage() {
    return <RedirectPage />;
}
